import React from "react";
import Header from "../Layout/Header";
import AboutUs from "../Layout/AboutUs";
import HIWB from "../Layout/HIWB";
import HIWC from "../Layout/HIWC";
import Numbers from "../Layout/Numbers";
import BusinessTypes from "../Layout/BusinessTypes";
import ContactUs from "../Layout/ContactUs";
import Footer from "../Layout/Footer";


const HomePage = () => {
document.title = "Carte Verte : La fidélité sans contraintes"
  return  <div>
    <Header />
    <AboutUs />
    <HIWB />
    <HIWC />
    <BusinessTypes />
    <Numbers />
    <ContactUs />
    <Footer />
  </div>
} 

export default HomePage;